var map = {
	"./anpassen.svg": "ed5d",
	"./delete.svg": "fa67",
	"./duplicate.svg": "415c",
	"./rename.svg": "00d2",
	"./settings.svg": "f8c1",
	"./share.svg": "6f5e",
	"./verlassen.svg": "87f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "99e9";